// src/directives/lazyload.js
import Vue from 'vue'

const lazyObserver = new Vue({
  data() {
    return {
      observer: null
    }
  },
  methods: {
    initObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const img = entry.target
              const src = img.dataset.src
              if (src) {
                img.src = src
                img.removeAttribute('data-src')
                this.observer.unobserve(img) // 加载后停止观察
              }
            }
          })
        },
        {
          rootMargin: '200px 0px 200px 0px', // 提前200px加载
          threshold: 0.1
        }
      )
    }
  },
  mounted() {
    this.initObserver()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect() // 销毁前断开观察器
    }
  }
})

// 注册全局指令
Vue.directive('lazyload', {
  inserted(el) {
    if (lazyObserver.observer) {
      lazyObserver.observer.unobserve(el)
      lazyObserver.observer.observe(el)
    }
  },
  componentUpdated(el) {
    if (lazyObserver.observer && el.dataset.src) {
      lazyObserver.observer.unobserve(el)
      lazyObserver.observer.observe(el)
    }
  },
  unbind(el) {
    if (lazyObserver.observer) {
      lazyObserver.observer.unobserve(el)
    }
  }
})
Vue.prototype.$lazyObserver = lazyObserver
